<section class="carousel">
  <div class="carousel-container start" #container (scroll)="onScroll($event)">
    <ng-content></ng-content>
  </div>
  <button (click)="scroll(-1)" class="prev" type="button" aria-label="Previous" title="Previous">Prev</button>
  <button (click)="scroll(+1)" class="next" type="button" aria-label="Next" title="Next">Next</button>
</section>